import * as R from 'ramda'

/* 
  This function creates class name for apply tailwind breakpoint 
  to class inside makeStyles. It requires theme object from makeStyles
  for get tailwind breakpoints values.
  
  Example:
  const useStyle = makeStyles(theme => ({
      customClass: {
        [useBreakpoints(theme).lessThan.sm]: {
          maxHeight: 100%,
        },
      },
  }));

  const CustomComponent {
    const classes = useStyle();
    return (<div className={classes.customClass} />);
  }
*/

export const useBreakpoints = (theme) => {
  return {
    lessThan: {
      sm: lessThan(theme, 'sm'),
      md: lessThan(theme, 'md'),
      lg: lessThan(theme, 'lg'),
      xl: lessThan(theme, 'xl'),
    },
    moreThan: {
      sm: moreThan(theme, 'sm'),
      md: moreThan(theme, 'md'),
      lg: moreThan(theme, 'lg'),
      xl: moreThan(theme, 'xl'),
    },
  }
}

const lessThan = (theme, breakpoints) => {
  return `@media only screen and (max-width: ${R.o(
    R.dec,
    R.path(['breakpoints', 'values', breakpoints]),
    theme,
  )}px)`
}

const moreThan = (theme, breakpoints) => {
  return `@media only screen and (min-width: ${R.path(
    ['breakpoints', 'values', breakpoints],
    theme,
  )}px)`
}
